var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "#003E6B",
    stroke: "#FAAC48",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 12.3714L10.125 7.5V11.2428H14.625V7.50002L20.25 12.3714L14.625 17.2428V13.4928H10.125V17.2428L4.5 12.3714Z",
    fill: "#FAAC48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumb);
export default __webpack_public_path__ + "static/media/thumb.31ed5b348f549dc2aac23c006f9277c2.svg";
export { ForwardRef as ReactComponent };